import GameModel from "../../GameModel";
import { Settings } from "../../Settings";
import GameTime from "../time/GameTime";
import BooleanValue from "../value/BooleanValue";
import NumberValue from "../value/NumberValue";

export default class BaseAutomation extends GameModel {
    /**
     * @param {GameTime} gameTime
     * @param {BooleanValue} automationUnlockedValue 
     * @param {NumberValue} automationRateUpgrades
     * @param {number} baseUpgradeDelayTurns
     * @param {number} turnsPerRateUpgrade
     */
    constructor(gameTime, automationUnlockedValue, automationRateUpgrades, baseUpgradeDelayTurns, turnsPerRateUpgrade) {
        super();
        
        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;

        /**
         * @constant
         * @type {BooleanValue}
         */
        this.automationUnlockedValue = automationUnlockedValue;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.automationRateUpgrades = automationRateUpgrades;

        /**
         * @constant
         * @type {number}
         */
        this.baseUpgradeDelayTurns = baseUpgradeDelayTurns;
        /**
         * @constant
         * @type {number}
         */
        this.turnsPerRateUpgrade = turnsPerRateUpgrade;


        /**
         * @type {number}
         */
        this.lastAutomationTurn = 0;
        /**
         * @type {number}
         */
        this.lastAutomationFrame = 0;

        /**
         * @type {boolean}
         */
        this.active = true;
    }

    /**
     * @returns {number}
     */
    getDelayTurns() {
        return Math.max(Settings.automation.minDelayTurns, this.baseUpgradeDelayTurns - (this.automationRateUpgrades.getValue() * this.turnsPerRateUpgrade));        
    }

    updateForTurn() {
        if (!this.active) {
            return;
        }
        if (!this.automationUnlockedValue.isValue()) {
            return;
        }

        const turnNumber = this.gameTime.turnNumber;
        const delayTurns = this.getDelayTurns();

        const elapsedTurns = turnNumber - this.lastAutomationTurn;
        if (elapsedTurns < delayTurns) {
            return;
        }

        this.lastAutomationTurn = turnNumber;
        this.lastAutomationFrame = this.gameTime.frameNumber;
        
        this.purchaseUpgrade();
    }

    /**
     * @abstract
     */
    purchaseUpgrade() {
    }

    /**
     * @returns {boolean}
     */
    isUnlocked() {
        return this.automationUnlockedValue.isValue();
    }

    toggleActiveFlag() {
        this.active = !this.active;
    }

    /**
     * When activated, this return the percent of the activation period completed.
     * @returns {number}
     */
    getActivationPercent() {
        if (!this.active) {
            return 0;
        }

        const delayFrames = this.getDelayTurns() * Settings.time.turnFrames;

        const elapsedFrames = this.gameTime.frameNumber - this.lastAutomationFrame;
        const ratio = Math.min(1.0, elapsedFrames / delayFrames);

        return (ratio * 100) | 0;
    }

    /////////////////////////////////////////
    // GameModel
    /////////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.lastAutomationTurn = 0;
        this.lastAutomationFrame = 0;
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.lastAutomationTurn = 0;
        this.lastAutomationFrame = 0;
    }
}